'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _compose = require('recompose/compose');

var _compose2 = _interopRequireDefault(_compose);

var _setPropTypes = require('recompose/setPropTypes');

var _setPropTypes2 = _interopRequireDefault(_setPropTypes);

var _isPlainObject = require('lodash/fp/isPlainObject');

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _injectOuterProps = require('./injectOuterProps');

var _injectOuterProps2 = _interopRequireDefault(_injectOuterProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var consumeProps = function consumeProps(arg) {
  var injectEnahncer = (0, _injectOuterProps2.default)(arg, true);

  if (!(0, _isPlainObject2.default)(arg)) return injectEnahncer;
  return (0, _compose2.default)(injectEnahncer, (0, _setPropTypes2.default)(arg));
};

exports.default = consumeProps;


//////////////////
// WEBPACK FOOTER
// ./~/recompose-scope/consumeProps.js
// module id = 1159
// module chunks = 0